"use client"

import { useFormContext } from "react-hook-form"

import { ArrayField } from "./fields/array-field"
import { BooleanField } from "./fields/boolean-field"
import { EnumField } from "./fields/enum-field"
import { IntegerField } from "./fields/integer-field"
import { NumberField } from "./fields/number-field"
import { ObjectField } from "./fields/object-field"
import { PromptField } from "./fields/prompt-field"
import { StringField } from "./fields/string-field"
import type { ParsedField } from "./types"

interface SchemaFieldRendererProps {
	field: ParsedField
	/** array 필드의 항목 추가 버튼 라벨 — 소비 앱에서 i18n 번역값을 주입한다 (ArrayField 로 전달) */
	addItemLabel?: string
}

export function SchemaFieldRenderer({ field, addItemLabel }: SchemaFieldRendererProps) {
	const { name, schema } = field
	const { register } = useFormContext()

	// x-ui-hidden: 폼 값은 유지하되 UI에서 숨김
	if (schema["x-ui-hidden"]) {
		return <input type="hidden" {...register(name)} />
	}

	if (schema.enum) {
		return <EnumField field={field} />
	}

	switch (schema.type) {
		case "string":
			// Use PromptField for prompt fields with custom handlers
			if (name === "prompt" || schema["x-ui-on-file-upload"] || schema["x-ui-on-random"]) {
				return <PromptField field={field} />
			}
			return <StringField field={field} />

		case "integer":
			return <IntegerField field={field} />

		case "number":
			return <NumberField field={field} />

		case "boolean":
			return <BooleanField field={field} />

		case "object":
			return <ObjectField field={field} />

		case "array":
			return <ArrayField field={field} addItemLabel={addItemLabel} />

		default:
			return (
				<div className="rounded-lg border border-destructive p-4">
					<p className="text-sm text-destructive">지원하지 않는 필드 타입: {schema.type}</p>
					<p className="text-xs text-muted-foreground mt-1">필드명: {name}</p>
				</div>
			)
	}
}
